export default "__VITE_ASSET__39d815c9__"